module.exports = __webpack_public_path__ + "img/Piece-18-1-mobile.8f366c5f.png";